import React, { useEffect } from "react";
import Vector from "../../../Asset/bestseller/Vector.png";
import { useNavigate } from "react-router-dom";
import { FaArrowCircleRight } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";

const Card = ({ item }) => {
  const Navigate = useNavigate();


  return (
    <div data-aos="fade-right" className="pt-16 w-full h-full  relative flex transform transition duration-300 hover:scale-105"  onClick={()=>{
     Navigate(`/product/${item?._id}/${item?.type}`)
    }}>
      <div className=" p-3 md:p-8 lg:p-6 w-28 h-28 sm:w-36 sm:h-36 lg:w-24 lg:h-24 xl:h-24 xl:w-24 absolute bg-Background8 top-0 sm:-top-2 right-8  lg:right-5 2xl:right-5 shadow-xl rounded-3xl cursor-pointer z-10">
        <img
          src={item?.image?.location}
          className="w-full object-cover  h-full "
          alt=""
        />
      </div>
      <div className="bg-white rounded-2xl flex w-full h-full justify-between cursor-pointer relative">
        <div className="flex items-center  w-1/2 ">
          <span className=" w-full text-end  text-xl md:text-2xl lg:text-xl text-textColor ">
            {item?.name}
          </span>
        </div>
        <div className="w-1/2 flex flex-col pt-24 lg:pt-14 ">
          <img src={Vector} alt="ima" className="w-full h-full" />
        </div>
        <FaArrowCircleRight className="absolute bottom-4 sm-right-10 md:bottom-3 right-4 md:right-3 xl:right-5 text-4xl sm:text-6xl md:text-5xl lg:text-4xl xl:text-4xl lg:bottom-2 lg:right-2 text-gray-600"/>
      </div>
    </div>
  );
};

export default Card;
